<template>
  <BCard class="relative overflow-hidden">
    <div
      class="absolute -bottom-[100px] -right-[80px] z-0"
    >
      <img
        :src="platformBackground"
        alt="background"
        width="220"
        height="220"
        className="object-contain"
      >
    </div>
    <div class="relative z-5">
      <div class="flex flex-row justify-between items-center">
        <div class="flex flex-row">
          <span class="text-gray-600 font-medium">Total Spending {{ platformName }}</span>
          <img
            v-b-tooltip.hover
            :title="`Informasi spending untuk platform ${platformName}`"
            src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
            alt="info"
            width="14"
            height="14"
            class="ml-[4px]"
          >
        </div>
        <BButton
          variant="outline-secondary"
          size="sm"
          class="rounded p-[4px]"
          :disabled="!(status === 'accepted' || isGamificationClaim)"
          @click="goToPlatformDetail"
        >
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/note-text.svg"
            alt="note-text"
            width="16"
            height="16"
          >
        </BButton>
      </div>

      <!-- Total Spending -->
      <div class="mb-[16px]">
        <div class="text-[32px] font-bold text-black mb-1">
          {{ totalSpending }}
        </div>
        <div class="text-[#828282] text-sm">
          Saldo Terupdate pada : {{ lastUpdateDate !== '-' ? formatDate(lastUpdateDate) : '-' }}

        </div>
      </div>

      <!-- Action Button -->
      <BButton
        v-if="status === 'on review' || status === 'not_active' || !status"
        :variant="status === 'on review' ? 'primary' : 'secondary'"
        size="sm"
        class="w-full rounded"
        :disabled="status === 'not_active' || !status"
        @click="handleTinjauPengajuan"
      >
        Tinjau Pengajuan
      </BButton>
      <!-- Badge -->
      <span
        v-if="status === 'accepted' && subscribeBadge"
        class="px-1 py-0.5 rounded-full text-center capitalize border-[1px]"
        :class="subscribeBadge.color"
      >
        {{ subscribeBadge.text }}
      </span>
    </div>
  </BCard>
</template>

<script>
import { MONTH_YEAR, DAY_MONTH_YEAR } from '@/libs/filterDate'
import { status } from '@/views/pages/komcards/data-partner/config'
import moment from 'moment'

export default {
  name: 'PlatformCard',
  props: {
    platform: {
      type: String,
      required: true,
      validator: value => ['meta', 'google', 'tiktok'].includes(value),
    },
    totalSpending: {
      type: String,
      default: '-',
    },
    lastUpdateDate: {
      type: [Number, String],
      default: '',
    },
    partnerId: {
      type: [Number, String],
      default: '',
    },
    requestId: {
      type: [Number, String],
      default: '',
    },
    status: {
      type: String,
      default: 'not_active',
    },
    expiredAt: {
      type: [Number, String],
      default: '',
    },
    isGamificationClaim: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    platformConfig() {
      const configs = {
        meta: {
          name: 'Meta',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg',
          background: 'https://storage.googleapis.com/komerce/komads-meta/bg-meta.svg',
        },
        google: {
          name: 'Google',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/google.svg',
          background: 'https://storage.googleapis.com/komerce/komads-meta/bg-google.svg',
        },
        tiktok: {
          name: 'TikTok',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg',
          background: 'https://storage.googleapis.com/komerce/komads-meta/bg-tiktok.svg',
        },
      }
      return configs[this.platform] || configs.meta
    },
    platformName() {
      return this.platformConfig.name
    },
    platformIcon() {
      return this.platformConfig.icon
    },
    platformBackground() {
      return this.platformConfig.background
    },
    currentMonth() {
      return MONTH_YEAR(moment())
    },
    subscribeBadge() {
      if (!this.expiredAt) return null

      const expiredDate = moment(this.expiredAt)

      const BADGE_CLASSES = {
        ACTIVE: 'bg-blue-100 text-blue-500 !border !border-blue-500',
        EXPIRED: 'bg-red-100 text-red-500 !border !border-red-500',
      }
      if (expiredDate.isBefore(moment())) {
        return {
          color: BADGE_CLASSES.EXPIRED,
          text: 'Expired',
        }
      }
      return {
        color: BADGE_CLASSES.ACTIVE,
        text: `Aktif hingga ${DAY_MONTH_YEAR(expiredDate)}`,
      }
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('dddd, DD MMMM YYYY HH:mm [WIB]')
    },
    handleTinjauPengajuan() {
      // Navigate to detail page with search params
      this.$router.push({
        path: '/komads/setup-whitelisted',
        query: {
          id: this.requestId,
          platform: this.platform,
        },
      })
    },
    goToPlatformDetail() {
      // Navigate to platform detail page
      this.$router.push({
        path: `/komads/data-partner/${this.partnerId}/detail`,
        query: {
          platform: this.platform,
        },
      })
    },
  },
}
</script>

<style scoped>
.btn-primary {
  background-color: #7367f0;
  border-color: #7367f0;
}

.btn-primary:hover {
  background-color: #5e50ee;
  border-color: #5e50ee;
}
</style>
